import React, { useState, Fragment, useCallback } from "react";
import { AttachFile, AlternateEmail, People, ChatBubble, Message, Close, Business, LockOpen, SwapHoriz, } from "@material-ui/icons";
import { NewCaseNoteDialog } from "./dialogs/NewCaseNoteDialog";
import { NewDocumentDialog } from "./dialogs/NewDocumentDialog";
import { TransferCaseDialog } from "./dialogs/TransferCaseDialog";
import { useAuthorizationForCase } from "../../../hooks/useAuthorization";
import { CaseRoles } from "../../../auth/CaseRoles";
import { NewCaseCommsDialog } from "./dialogs/NewCaseCommsDialog";
import { CloseCaseDialog } from "./dialogs/CloseCaseDialog";
import { ContactAODialog } from "./dialogs/ContactAODialog";
import { EmailAttachDialog } from "./dialogs/EmailAttachDialog";
import { ReopenCaseDialog } from "./dialogs/ReopenCaseDialog";
import { Button } from "@material-ui/core";
import { InternalMessageDialog } from "./dialogs/InternalMessageDialog";
import { userAuthService } from "../../../auth/UserAuthService";
import { ExperimentalFeature } from "@ofqual/portal-components/components/ExperimentalFeature";
const CLOSED_STATUS = "Closed";
export const ActivitiesFooter = ({ model }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const isAuthedForAddActivity = useAuthorizationForCase(model.id, CaseRoles.admin, CaseRoles.collaborator);
    const isAuthedForContactCitizen = useAuthorizationForCase(model.id, CaseRoles.admin);
    const onClose = useCallback(() => setOpenDialog(false), []);
    const experimentalFeatures = userAuthService.getExperimentalFeatures() || [];
    const allActions = [
        {
            startIcon: React.createElement(AttachFile, null),
            title: "Attach Document",
            onClick: () => {
                setOpenDialog("Document");
            },
            disabled: !isAuthedForAddActivity,
            "data-test": "activity-document",
        },
        {
            startIcon: React.createElement(AlternateEmail, null),
            title: "Attach Email",
            onClick: () => {
                setOpenDialog("AttachEmail");
            },
            disabled: !isAuthedForAddActivity,
            "data-test": "activity-email",
        },
        {
            startIcon: React.createElement(People, null),
            title: "Contact Citizen",
            onClick: () => {
                setOpenDialog("Comms");
            },
            disabled: !isAuthedForContactCitizen,
            "data-test": "activity-contact",
        },
        {
            startIcon: React.createElement(Business, null),
            title: "Contact AO",
            onClick: () => {
                setOpenDialog("ContactAO");
            },
            disabled: !isAuthedForAddActivity,
            "data-test": "activity-contact-ao",
        },
        {
            startIcon: React.createElement(ChatBubble, null),
            title: "Add Case Note",
            onClick: () => {
                setOpenDialog("CaseNote");
            },
            "data-test": "activity-note",
        },
        model.status === CLOSED_STATUS
            ? {
                startIcon: React.createElement(LockOpen, null),
                title: "Reopen Case",
                onClick: () => {
                    setOpenDialog("Reopen");
                },
                disabled: !isAuthedForAddActivity,
                "data-test": "activity-reopen",
            }
            : {
                startIcon: React.createElement(Close, null),
                title: "Close Case",
                onClick: () => {
                    setOpenDialog("Close");
                },
                disabled: !isAuthedForAddActivity,
                "data-test": "activity-close",
            },
    ];
    const transferCaseAction = {
        startIcon: React.createElement(SwapHoriz, null),
        title: "Transfer Case",
        onClick: () => {
            setOpenDialog("Transfer");
        },
        disabled: !isAuthedForAddActivity,
        "data-test": "activity-transfer",
    };
    const internalMessageAction = {
        startIcon: React.createElement(Message, null),
        title: "Internal message",
        onClick: () => {
            setOpenDialog("InternalMessage");
        },
        disabled: !isAuthedForAddActivity,
        "data-test": "internal-message",
    };
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: "RecordFooterBar", "data-test": "footer" },
            React.createElement(ExperimentalFeature, { experimentalModuleName: "complaints", experimentalFeatures: experimentalFeatures, experimentalFeatureVisibleName: "internalMessage" }, [internalMessageAction, ...allActions].map((action, index) => (React.createElement("div", { key: index, className: "section" },
                React.createElement("span", null,
                    React.createElement(Button, Object.assign({}, action), action.title)))))),
            React.createElement(ExperimentalFeature, { experimentalModuleName: "complaints", experimentalFeatures: experimentalFeatures, experimentalFeatureHiddenName: "internalMessage" }, [transferCaseAction, ...allActions].map((action, index) => (React.createElement("div", { key: index, className: "section" },
                React.createElement("span", null,
                    React.createElement(Button, Object.assign({}, action), action.title))))))),
        openDialog === "CaseNote" && (React.createElement(NewCaseNoteDialog, { caseId: model.id, stage: model.stage, isDialogOpen: openDialog === "CaseNote", onDialogClose: onClose })),
        openDialog === "Document" && (React.createElement(NewDocumentDialog, { caseId: model.id, stage: model.stage, isDialogOpen: openDialog === "Document", onDialogClose: onClose })),
        openDialog === "Transfer" && (React.createElement(TransferCaseDialog, { caseId: model.id, isDialogOpen: openDialog === "Transfer", onDialogClose: onClose })),
        openDialog === "Close" && (React.createElement(CloseCaseDialog, { caseId: model.id, isDialogOpen: openDialog === "Close", onDialogClose: onClose })),
        openDialog === "Reopen" && (React.createElement(ReopenCaseDialog, { caseId: model.id, isDialogOpen: openDialog === "Reopen", onDialogClose: onClose })),
        openDialog === "Comms" && (React.createElement(NewCaseCommsDialog, { caseId: model.id, isDialogOpen: openDialog === "Comms", onDialogClose: onClose, hasEmailAddress: !!model.contacts && model.contacts.some((c) => !!c.email), isWhistleblower: model.caseType === "whistleblower" || model.caseType === "malpractice" })),
        openDialog === "ContactAO" && (React.createElement(ContactAODialog, { caseId: model.id, isDialogOpen: openDialog === "ContactAO", onDialogClose: onClose })),
        openDialog === "AttachEmail" && (React.createElement(EmailAttachDialog, { caseId: model.id, isDialogOpen: openDialog === "AttachEmail", onDialogClose: onClose })),
        openDialog === "InternalMessage" && (React.createElement(InternalMessageDialog, { caseId: model.id, isDialogOpen: openDialog === "InternalMessage", onDialogClose: onClose }))));
};
